module.exports = ".code, code {\n  display: block !important;\n  z-index: 1000 !important; }\n  .code.hidden, code.hidden {\n    display: none !important; }\n  .cpui-app {\n  z-index: 1; }\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./node_modules/sass-loader/lib/loader.js??ref--8-3!./src/mock.scss
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./node_modules/sass-loader/lib/loader.js??ref--8-3!./src/mock.scss
// module chunks = styles